/**
 * SDK selector. Picks the Mock SDK in local dev (outside Discord) and the real Discord SDK
 * inside Discord / production. The real SDK is imported lazily so the mock path (and tests)
 * never load the Embedded App SDK.
 */
import { shouldUseMock } from './env.js';
import { MockActivitySdk } from './mockSdk.js';
import type { ActivitySdk } from './types.js';

export async function createActivitySdk(): Promise<ActivitySdk> {
  if (shouldUseMock()) {
    return new MockActivitySdk();
  }
  const { RealActivitySdk } = await import('./realSdk.js');
  return new RealActivitySdk();
}

export type { ActivitySdk, ActivityContext, ActivityUser } from './types.js';
export { isInDiscord, shouldUseMock, launchParams, apiBase, discordClientId } from './env.js';
